import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/v1/users', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/v1/users/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/v1/users', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
  return httpClient
    .put(`/api/v1/users/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/v1/users/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const permission = (Options = {}) => {
  return httpClient
    .get('/api/v1/users/permissions', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const role = (Options = {}) => {
  return httpClient
    .get('/api/v1/users/roles', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const employee = (Options = {}) => {
  return httpClient
    .get('/api/v1/users/employees', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const branch = (Options = {}) => {
  return httpClient
    .get('/api/v1/users/branches', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const passwordReset = (id, data) => {
  return httpClient
    .put(`/api/v1/users/${id}/reset/passwords`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const branchAssigned = (Options = {}) => {
  return httpClient
    .get('/api/v1/users/branch-assigned', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const warehouseAssigned = (Options = {}) => {
  return httpClient
    .get('/api/v1/users/warehouse-assigned', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const unlock = data => {
  return httpClient
    .post('/api/v1/users/unlock', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const switchDefaultBranch = data => {
  return httpClient
    .post('/api/v1/users/switch-branches', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const changePassword = data => {
  return httpClient
    .post('/api/v1/users/change-password', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const mobileRole = (Options = {}) => {
  return httpClient
    .get('/api/v1/users/mobile-roles', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const reportTo = (parent_id, Options = {}) => {
  return httpClient
    .get(`/api/v1/users/${parent_id}/report-to`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const counter = (Options = {}) => {
  return httpClient
    .get('/api/v1/users/counters', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default { 
  get, 
  find, 
  store, 
  update, 
  destroy, 
  permission, 
  role, 
  employee, 
  branch, 
  passwordReset,
  branchAssigned,
  warehouseAssigned,
  unlock,
  switchDefaultBranch,
  changePassword,
  mobileRole,
  reportTo,
  counter
}
